export default __webpack_public_path__ + "7c67b2146e3af75675f75348f78e7a64.png";